<cec-dialog
  [headerKey]="id ? 'EditRound' : 'CreateRound'"
  [disableConfirmButton]="!name"
  (onButtonClicked)="onClickButton($event)">
  <mat-form-field appearance="fill">
    <mat-label>{{'Round name' | translate}}</mat-label>
    <input matInput placeholder="{{'Round name' | translate}}" [(ngModel)]="name" required>
  </mat-form-field>  
</cec-dialog>



